import React from 'react'
import { HiX } from 'react-icons/hi'
import classNames from 'classnames'
import { safeBlur } from 'utils/safeFocus'

const CloseButton = React.forwardRef((props, ref) => {
    const { absolute, className, defaultStyle, svgClass, onClick, ...rest } = props
    const closeButtonAbsoluteClass = 'absolute z-10'

    const closeButtonClass = classNames(
        'close-btn',
        defaultStyle && 'close-btn-default',
        absolute && closeButtonAbsoluteClass,
        className
    )

    const handleMouseDown = (e) => {
        // Prevent the button from receiving focus on mousedown
        // This fixes Firefox mobile "Script error" when clicking close buttons
        // in modals/drawers - the focus would conflict with the closing animation
        e.preventDefault()
    }

    const handleClick = (e) => {
        // Safely blur any existing focus before triggering close
        safeBlur()
        onClick?.(e)
    }

    return (
        <button 
            type="button"
            className={closeButtonClass} 
            onMouseDown={handleMouseDown}
            onClick={handleClick}
            {...rest} 
            ref={ref}
        >
            <HiX />
        </button>
    )
})

CloseButton.defaultProps = {
    defaultStyle: true,
}

export default CloseButton
